// Generated from src/antlr/formula.g4 by ANTLR 4.13.2

import { ParseTreeListener } from 'antlr4'

import { ExprContext } from './formulaParser.js'
import { InvalidInputContext } from './formulaParser.js'
import { SumExpressionContext } from './formulaParser.js'
import { SingleTermContext } from './formulaParser.js'
import { AdditionExprContext } from './formulaParser.js'
import { SubtractionExprContext } from './formulaParser.js'
import { SingleFactorContext } from './formulaParser.js'
import { MultiplicationExprContext } from './formulaParser.js'
import { DivisionExprContext } from './formulaParser.js'
import { NestedSumExprContext } from './formulaParser.js'
import { FunctionContext } from './formulaParser.js'
import { ColumnRefContext } from './formulaParser.js'
import { NumberContext } from './formulaParser.js'
import { NegativeNumberContext } from './formulaParser.js'
import { StringLiteralContext } from './formulaParser.js'
import { TodayLiteralContext } from './formulaParser.js'
import { NowLiteralContext } from './formulaParser.js'
import { SingleArgumentFunctionContext } from './formulaParser.js'
import { MultipleArgumentsFunctionContext } from './formulaParser.js'
import { TwoArgumentsFunctionContext } from './formulaParser.js'
import { ThreeArgumentsFunctionContext } from './formulaParser.js'
import { IfFunctionContext } from './formulaParser.js'
import { IfsFunctionContext } from './formulaParser.js'
import { SingleExpressionContext } from './formulaParser.js'
import { MultipleExpressionsContext } from './formulaParser.js'
import { TwoExpressionArgsContext } from './formulaParser.js'
import { ThreeExpressionArgsContext } from './formulaParser.js'
import { TwoExpressionsContext } from './formulaParser.js'
import { EvenExpressionsContext } from './formulaParser.js'
import { SumFunctionContext } from './formulaParser.js'
import { CountFunctionContext } from './formulaParser.js'
import { CountDistinctFunctionContext } from './formulaParser.js'
import { CeilFunctionContext } from './formulaParser.js'
import { FloorFunctionContext } from './formulaParser.js'
import { UpperFunctionContext } from './formulaParser.js'
import { LowerFunctionContext } from './formulaParser.js'
import { TrimFunctionContext } from './formulaParser.js'
import { LenFunctionContext } from './formulaParser.js'
import { YearFunctionContext } from './formulaParser.js'
import { MonthFunctionContext } from './formulaParser.js'
import { DayFunctionContext } from './formulaParser.js'
import { ToTextFunctionContext } from './formulaParser.js'
import { ToNumberFunctionContext } from './formulaParser.js'
import { MaxFunctionContext } from './formulaParser.js'
import { MinFunctionContext } from './formulaParser.js'
import { AverageFunctionContext } from './formulaParser.js'
import { SumProductFunctionContext } from './formulaParser.js'
import { ConcatFunctionContext } from './formulaParser.js'
import { RoundFunctionContext } from './formulaParser.js'
import { ToDateFunctionContext } from './formulaParser.js'
import { LeftFunctionContext } from './formulaParser.js'
import { RightFunctionContext } from './formulaParser.js'
import { SubstituteFunctionContext } from './formulaParser.js'
import { MidFunctionContext } from './formulaParser.js'
import { DateFunctionContext } from './formulaParser.js'
import { DateaddFunctionContext } from './formulaParser.js'
import { DatediffFunctionContext } from './formulaParser.js'
import { SumIfFunctionContext } from './formulaParser.js'
import { CountIfFunctionContext } from './formulaParser.js'
import { AverageIfFunctionContext } from './formulaParser.js'
import { MinIfsFunctionContext } from './formulaParser.js'
import { MaxIfsFunctionContext } from './formulaParser.js'
import { SingleLogicExprContext } from './formulaParser.js'
import { ParenthesizedLogicExprContext } from './formulaParser.js'
import { OrChainedLogicExprContext } from './formulaParser.js'
import { AndChainedLogicExprContext } from './formulaParser.js'
import { ParenthesizedLogicTermContext } from './formulaParser.js'
import { NotExpressionContext } from './formulaParser.js'
import { BooleanExpressionContext } from './formulaParser.js'
import { ComparisonExpressionContext } from './formulaParser.js'
import { ScalarRightContainsExpressionContext } from './formulaParser.js'
import { ArrayRightContainsExpressionContext } from './formulaParser.js'
import { UnaryExpressionContext } from './formulaParser.js'
import { InExpressionContext } from './formulaParser.js'
import { NotExprContext } from './formulaParser.js'
import { BinaryLogicExprContext } from './formulaParser.js'
import { ScalarRightContainsExprContext } from './formulaParser.js'
import { ArrayRightContainsExprContext } from './formulaParser.js'
import { InExprContext } from './formulaParser.js'
import { UnaryExprContext } from './formulaParser.js'
import { LogicExprColumnRefContext } from './formulaParser.js'
import { FormulaInLogicContext } from './formulaParser.js'
import { DirectValueContext } from './formulaParser.js'
import { GreaterThanContext } from './formulaParser.js'
import { GreaterThanOrEqualContext } from './formulaParser.js'
import { LessThanContext } from './formulaParser.js'
import { LessThanOrEqualContext } from './formulaParser.js'
import { EqualContext } from './formulaParser.js'
import { NotEqualContext } from './formulaParser.js'
import { ContainsAnyContext } from './formulaParser.js'
import { ContainsAllContext } from './formulaParser.js'
import { DoesNotContainAnyContext } from './formulaParser.js'
import { ContainsContext } from './formulaParser.js'
import { DoesNotContainContext } from './formulaParser.js'
import { InContext } from './formulaParser.js'
import { NotInContext } from './formulaParser.js'
import { IsEmptyContext } from './formulaParser.js'
import { IsNotEmptyContext } from './formulaParser.js'
import { NumericValueContext } from './formulaParser.js'
import { NegativeNumericValueContext } from './formulaParser.js'
import { StringValueContext } from './formulaParser.js'
import { BooleanValueContext } from './formulaParser.js'
import { NumericValueListContext } from './formulaParser.js'
import { StringValueListContext } from './formulaParser.js'
import { NumericItemContext } from './formulaParser.js'
import { NegativeNumericItemContext } from './formulaParser.js'
import { StringItemContext } from './formulaParser.js'

/**
 * This interface defines a complete listener for a parse tree produced by
 * `formulaParser`.
 */
export default class formulaListener extends ParseTreeListener {
  /**
   * Enter a parse tree produced by `formulaParser.expr`.
   * @param ctx the parse tree
   */
  enterExpr?: (ctx: ExprContext) => void
  /**
   * Exit a parse tree produced by `formulaParser.expr`.
   * @param ctx the parse tree
   */
  exitExpr?: (ctx: ExprContext) => void
  /**
   * Enter a parse tree produced by `formulaParser.invalidInput`.
   * @param ctx the parse tree
   */
  enterInvalidInput?: (ctx: InvalidInputContext) => void
  /**
   * Exit a parse tree produced by `formulaParser.invalidInput`.
   * @param ctx the parse tree
   */
  exitInvalidInput?: (ctx: InvalidInputContext) => void
  /**
   * Enter a parse tree produced by the `sumExpression`
   * labeled alternative in `formulaParser.formulaExpr`.
   * @param ctx the parse tree
   */
  enterSumExpression?: (ctx: SumExpressionContext) => void
  /**
   * Exit a parse tree produced by the `sumExpression`
   * labeled alternative in `formulaParser.formulaExpr`.
   * @param ctx the parse tree
   */
  exitSumExpression?: (ctx: SumExpressionContext) => void
  /**
   * Enter a parse tree produced by the `singleTerm`
   * labeled alternative in `formulaParser.sumExpr`.
   * @param ctx the parse tree
   */
  enterSingleTerm?: (ctx: SingleTermContext) => void
  /**
   * Exit a parse tree produced by the `singleTerm`
   * labeled alternative in `formulaParser.sumExpr`.
   * @param ctx the parse tree
   */
  exitSingleTerm?: (ctx: SingleTermContext) => void
  /**
   * Enter a parse tree produced by the `additionExpr`
   * labeled alternative in `formulaParser.sumExpr`.
   * @param ctx the parse tree
   */
  enterAdditionExpr?: (ctx: AdditionExprContext) => void
  /**
   * Exit a parse tree produced by the `additionExpr`
   * labeled alternative in `formulaParser.sumExpr`.
   * @param ctx the parse tree
   */
  exitAdditionExpr?: (ctx: AdditionExprContext) => void
  /**
   * Enter a parse tree produced by the `subtractionExpr`
   * labeled alternative in `formulaParser.sumExpr`.
   * @param ctx the parse tree
   */
  enterSubtractionExpr?: (ctx: SubtractionExprContext) => void
  /**
   * Exit a parse tree produced by the `subtractionExpr`
   * labeled alternative in `formulaParser.sumExpr`.
   * @param ctx the parse tree
   */
  exitSubtractionExpr?: (ctx: SubtractionExprContext) => void
  /**
   * Enter a parse tree produced by the `singleFactor`
   * labeled alternative in `formulaParser.term`.
   * @param ctx the parse tree
   */
  enterSingleFactor?: (ctx: SingleFactorContext) => void
  /**
   * Exit a parse tree produced by the `singleFactor`
   * labeled alternative in `formulaParser.term`.
   * @param ctx the parse tree
   */
  exitSingleFactor?: (ctx: SingleFactorContext) => void
  /**
   * Enter a parse tree produced by the `multiplicationExpr`
   * labeled alternative in `formulaParser.term`.
   * @param ctx the parse tree
   */
  enterMultiplicationExpr?: (ctx: MultiplicationExprContext) => void
  /**
   * Exit a parse tree produced by the `multiplicationExpr`
   * labeled alternative in `formulaParser.term`.
   * @param ctx the parse tree
   */
  exitMultiplicationExpr?: (ctx: MultiplicationExprContext) => void
  /**
   * Enter a parse tree produced by the `divisionExpr`
   * labeled alternative in `formulaParser.term`.
   * @param ctx the parse tree
   */
  enterDivisionExpr?: (ctx: DivisionExprContext) => void
  /**
   * Exit a parse tree produced by the `divisionExpr`
   * labeled alternative in `formulaParser.term`.
   * @param ctx the parse tree
   */
  exitDivisionExpr?: (ctx: DivisionExprContext) => void
  /**
   * Enter a parse tree produced by the `nestedSumExpr`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterNestedSumExpr?: (ctx: NestedSumExprContext) => void
  /**
   * Exit a parse tree produced by the `nestedSumExpr`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitNestedSumExpr?: (ctx: NestedSumExprContext) => void
  /**
   * Enter a parse tree produced by the `function`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterFunction?: (ctx: FunctionContext) => void
  /**
   * Exit a parse tree produced by the `function`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitFunction?: (ctx: FunctionContext) => void
  /**
   * Enter a parse tree produced by the `columnRef`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterColumnRef?: (ctx: ColumnRefContext) => void
  /**
   * Exit a parse tree produced by the `columnRef`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitColumnRef?: (ctx: ColumnRefContext) => void
  /**
   * Enter a parse tree produced by the `number`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterNumber?: (ctx: NumberContext) => void
  /**
   * Exit a parse tree produced by the `number`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitNumber?: (ctx: NumberContext) => void
  /**
   * Enter a parse tree produced by the `negativeNumber`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterNegativeNumber?: (ctx: NegativeNumberContext) => void
  /**
   * Exit a parse tree produced by the `negativeNumber`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitNegativeNumber?: (ctx: NegativeNumberContext) => void
  /**
   * Enter a parse tree produced by the `stringLiteral`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterStringLiteral?: (ctx: StringLiteralContext) => void
  /**
   * Exit a parse tree produced by the `stringLiteral`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitStringLiteral?: (ctx: StringLiteralContext) => void
  /**
   * Enter a parse tree produced by the `todayLiteral`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterTodayLiteral?: (ctx: TodayLiteralContext) => void
  /**
   * Exit a parse tree produced by the `todayLiteral`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitTodayLiteral?: (ctx: TodayLiteralContext) => void
  /**
   * Enter a parse tree produced by the `nowLiteral`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  enterNowLiteral?: (ctx: NowLiteralContext) => void
  /**
   * Exit a parse tree produced by the `nowLiteral`
   * labeled alternative in `formulaParser.factor`.
   * @param ctx the parse tree
   */
  exitNowLiteral?: (ctx: NowLiteralContext) => void
  /**
   * Enter a parse tree produced by the `singleArgumentFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  enterSingleArgumentFunction?: (ctx: SingleArgumentFunctionContext) => void
  /**
   * Exit a parse tree produced by the `singleArgumentFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  exitSingleArgumentFunction?: (ctx: SingleArgumentFunctionContext) => void
  /**
   * Enter a parse tree produced by the `multipleArgumentsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  enterMultipleArgumentsFunction?: (ctx: MultipleArgumentsFunctionContext) => void
  /**
   * Exit a parse tree produced by the `multipleArgumentsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  exitMultipleArgumentsFunction?: (ctx: MultipleArgumentsFunctionContext) => void
  /**
   * Enter a parse tree produced by the `twoArgumentsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  enterTwoArgumentsFunction?: (ctx: TwoArgumentsFunctionContext) => void
  /**
   * Exit a parse tree produced by the `twoArgumentsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  exitTwoArgumentsFunction?: (ctx: TwoArgumentsFunctionContext) => void
  /**
   * Enter a parse tree produced by the `threeArgumentsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  enterThreeArgumentsFunction?: (ctx: ThreeArgumentsFunctionContext) => void
  /**
   * Exit a parse tree produced by the `threeArgumentsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  exitThreeArgumentsFunction?: (ctx: ThreeArgumentsFunctionContext) => void
  /**
   * Enter a parse tree produced by the `ifFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  enterIfFunction?: (ctx: IfFunctionContext) => void
  /**
   * Exit a parse tree produced by the `ifFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  exitIfFunction?: (ctx: IfFunctionContext) => void
  /**
   * Enter a parse tree produced by the `ifsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  enterIfsFunction?: (ctx: IfsFunctionContext) => void
  /**
   * Exit a parse tree produced by the `ifsFunction`
   * labeled alternative in `formulaParser.functionCall`.
   * @param ctx the parse tree
   */
  exitIfsFunction?: (ctx: IfsFunctionContext) => void
  /**
   * Enter a parse tree produced by the `singleExpression`
   * labeled alternative in `formulaParser.singleArg`.
   * @param ctx the parse tree
   */
  enterSingleExpression?: (ctx: SingleExpressionContext) => void
  /**
   * Exit a parse tree produced by the `singleExpression`
   * labeled alternative in `formulaParser.singleArg`.
   * @param ctx the parse tree
   */
  exitSingleExpression?: (ctx: SingleExpressionContext) => void
  /**
   * Enter a parse tree produced by the `multipleExpressions`
   * labeled alternative in `formulaParser.multipleArgs`.
   * @param ctx the parse tree
   */
  enterMultipleExpressions?: (ctx: MultipleExpressionsContext) => void
  /**
   * Exit a parse tree produced by the `multipleExpressions`
   * labeled alternative in `formulaParser.multipleArgs`.
   * @param ctx the parse tree
   */
  exitMultipleExpressions?: (ctx: MultipleExpressionsContext) => void
  /**
   * Enter a parse tree produced by the `twoExpressionArgs`
   * labeled alternative in `formulaParser.twoArgs`.
   * @param ctx the parse tree
   */
  enterTwoExpressionArgs?: (ctx: TwoExpressionArgsContext) => void
  /**
   * Exit a parse tree produced by the `twoExpressionArgs`
   * labeled alternative in `formulaParser.twoArgs`.
   * @param ctx the parse tree
   */
  exitTwoExpressionArgs?: (ctx: TwoExpressionArgsContext) => void
  /**
   * Enter a parse tree produced by the `threeExpressionArgs`
   * labeled alternative in `formulaParser.threeArgs`.
   * @param ctx the parse tree
   */
  enterThreeExpressionArgs?: (ctx: ThreeExpressionArgsContext) => void
  /**
   * Exit a parse tree produced by the `threeExpressionArgs`
   * labeled alternative in `formulaParser.threeArgs`.
   * @param ctx the parse tree
   */
  exitThreeExpressionArgs?: (ctx: ThreeExpressionArgsContext) => void
  /**
   * Enter a parse tree produced by the `twoExpressions`
   * labeled alternative in `formulaParser.ifArgs`.
   * @param ctx the parse tree
   */
  enterTwoExpressions?: (ctx: TwoExpressionsContext) => void
  /**
   * Exit a parse tree produced by the `twoExpressions`
   * labeled alternative in `formulaParser.ifArgs`.
   * @param ctx the parse tree
   */
  exitTwoExpressions?: (ctx: TwoExpressionsContext) => void
  /**
   * Enter a parse tree produced by the `evenExpressions`
   * labeled alternative in `formulaParser.ifsArgs`.
   * @param ctx the parse tree
   */
  enterEvenExpressions?: (ctx: EvenExpressionsContext) => void
  /**
   * Exit a parse tree produced by the `evenExpressions`
   * labeled alternative in `formulaParser.ifsArgs`.
   * @param ctx the parse tree
   */
  exitEvenExpressions?: (ctx: EvenExpressionsContext) => void
  /**
   * Enter a parse tree produced by the `sumFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterSumFunction?: (ctx: SumFunctionContext) => void
  /**
   * Exit a parse tree produced by the `sumFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitSumFunction?: (ctx: SumFunctionContext) => void
  /**
   * Enter a parse tree produced by the `countFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterCountFunction?: (ctx: CountFunctionContext) => void
  /**
   * Exit a parse tree produced by the `countFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitCountFunction?: (ctx: CountFunctionContext) => void
  /**
   * Enter a parse tree produced by the `countDistinctFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterCountDistinctFunction?: (ctx: CountDistinctFunctionContext) => void
  /**
   * Exit a parse tree produced by the `countDistinctFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitCountDistinctFunction?: (ctx: CountDistinctFunctionContext) => void
  /**
   * Enter a parse tree produced by the `ceilFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterCeilFunction?: (ctx: CeilFunctionContext) => void
  /**
   * Exit a parse tree produced by the `ceilFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitCeilFunction?: (ctx: CeilFunctionContext) => void
  /**
   * Enter a parse tree produced by the `floorFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterFloorFunction?: (ctx: FloorFunctionContext) => void
  /**
   * Exit a parse tree produced by the `floorFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitFloorFunction?: (ctx: FloorFunctionContext) => void
  /**
   * Enter a parse tree produced by the `upperFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterUpperFunction?: (ctx: UpperFunctionContext) => void
  /**
   * Exit a parse tree produced by the `upperFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitUpperFunction?: (ctx: UpperFunctionContext) => void
  /**
   * Enter a parse tree produced by the `lowerFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterLowerFunction?: (ctx: LowerFunctionContext) => void
  /**
   * Exit a parse tree produced by the `lowerFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitLowerFunction?: (ctx: LowerFunctionContext) => void
  /**
   * Enter a parse tree produced by the `trimFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterTrimFunction?: (ctx: TrimFunctionContext) => void
  /**
   * Exit a parse tree produced by the `trimFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitTrimFunction?: (ctx: TrimFunctionContext) => void
  /**
   * Enter a parse tree produced by the `lenFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterLenFunction?: (ctx: LenFunctionContext) => void
  /**
   * Exit a parse tree produced by the `lenFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitLenFunction?: (ctx: LenFunctionContext) => void
  /**
   * Enter a parse tree produced by the `yearFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterYearFunction?: (ctx: YearFunctionContext) => void
  /**
   * Exit a parse tree produced by the `yearFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitYearFunction?: (ctx: YearFunctionContext) => void
  /**
   * Enter a parse tree produced by the `monthFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterMonthFunction?: (ctx: MonthFunctionContext) => void
  /**
   * Exit a parse tree produced by the `monthFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitMonthFunction?: (ctx: MonthFunctionContext) => void
  /**
   * Enter a parse tree produced by the `dayFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterDayFunction?: (ctx: DayFunctionContext) => void
  /**
   * Exit a parse tree produced by the `dayFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitDayFunction?: (ctx: DayFunctionContext) => void
  /**
   * Enter a parse tree produced by the `toTextFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterToTextFunction?: (ctx: ToTextFunctionContext) => void
  /**
   * Exit a parse tree produced by the `toTextFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitToTextFunction?: (ctx: ToTextFunctionContext) => void
  /**
   * Enter a parse tree produced by the `toNumberFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  enterToNumberFunction?: (ctx: ToNumberFunctionContext) => void
  /**
   * Exit a parse tree produced by the `toNumberFunction`
   * labeled alternative in `formulaParser.singleArgFunctionType`.
   * @param ctx the parse tree
   */
  exitToNumberFunction?: (ctx: ToNumberFunctionContext) => void
  /**
   * Enter a parse tree produced by the `maxFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterMaxFunction?: (ctx: MaxFunctionContext) => void
  /**
   * Exit a parse tree produced by the `maxFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitMaxFunction?: (ctx: MaxFunctionContext) => void
  /**
   * Enter a parse tree produced by the `minFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterMinFunction?: (ctx: MinFunctionContext) => void
  /**
   * Exit a parse tree produced by the `minFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitMinFunction?: (ctx: MinFunctionContext) => void
  /**
   * Enter a parse tree produced by the `averageFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterAverageFunction?: (ctx: AverageFunctionContext) => void
  /**
   * Exit a parse tree produced by the `averageFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitAverageFunction?: (ctx: AverageFunctionContext) => void
  /**
   * Enter a parse tree produced by the `sumProductFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterSumProductFunction?: (ctx: SumProductFunctionContext) => void
  /**
   * Exit a parse tree produced by the `sumProductFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitSumProductFunction?: (ctx: SumProductFunctionContext) => void
  /**
   * Enter a parse tree produced by the `concatFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterConcatFunction?: (ctx: ConcatFunctionContext) => void
  /**
   * Exit a parse tree produced by the `concatFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitConcatFunction?: (ctx: ConcatFunctionContext) => void
  /**
   * Enter a parse tree produced by the `roundFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterRoundFunction?: (ctx: RoundFunctionContext) => void
  /**
   * Exit a parse tree produced by the `roundFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitRoundFunction?: (ctx: RoundFunctionContext) => void
  /**
   * Enter a parse tree produced by the `toDateFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterToDateFunction?: (ctx: ToDateFunctionContext) => void
  /**
   * Exit a parse tree produced by the `toDateFunction`
   * labeled alternative in `formulaParser.multipleArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitToDateFunction?: (ctx: ToDateFunctionContext) => void
  /**
   * Enter a parse tree produced by the `leftFunction`
   * labeled alternative in `formulaParser.twoArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterLeftFunction?: (ctx: LeftFunctionContext) => void
  /**
   * Exit a parse tree produced by the `leftFunction`
   * labeled alternative in `formulaParser.twoArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitLeftFunction?: (ctx: LeftFunctionContext) => void
  /**
   * Enter a parse tree produced by the `rightFunction`
   * labeled alternative in `formulaParser.twoArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterRightFunction?: (ctx: RightFunctionContext) => void
  /**
   * Exit a parse tree produced by the `rightFunction`
   * labeled alternative in `formulaParser.twoArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitRightFunction?: (ctx: RightFunctionContext) => void
  /**
   * Enter a parse tree produced by the `substituteFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterSubstituteFunction?: (ctx: SubstituteFunctionContext) => void
  /**
   * Exit a parse tree produced by the `substituteFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitSubstituteFunction?: (ctx: SubstituteFunctionContext) => void
  /**
   * Enter a parse tree produced by the `midFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterMidFunction?: (ctx: MidFunctionContext) => void
  /**
   * Exit a parse tree produced by the `midFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitMidFunction?: (ctx: MidFunctionContext) => void
  /**
   * Enter a parse tree produced by the `dateFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterDateFunction?: (ctx: DateFunctionContext) => void
  /**
   * Exit a parse tree produced by the `dateFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitDateFunction?: (ctx: DateFunctionContext) => void
  /**
   * Enter a parse tree produced by the `dateaddFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterDateaddFunction?: (ctx: DateaddFunctionContext) => void
  /**
   * Exit a parse tree produced by the `dateaddFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitDateaddFunction?: (ctx: DateaddFunctionContext) => void
  /**
   * Enter a parse tree produced by the `datediffFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  enterDatediffFunction?: (ctx: DatediffFunctionContext) => void
  /**
   * Exit a parse tree produced by the `datediffFunction`
   * labeled alternative in `formulaParser.threeArgsFunctionType`.
   * @param ctx the parse tree
   */
  exitDatediffFunction?: (ctx: DatediffFunctionContext) => void
  /**
   * Enter a parse tree produced by the `sumIfFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  enterSumIfFunction?: (ctx: SumIfFunctionContext) => void
  /**
   * Exit a parse tree produced by the `sumIfFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  exitSumIfFunction?: (ctx: SumIfFunctionContext) => void
  /**
   * Enter a parse tree produced by the `countIfFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  enterCountIfFunction?: (ctx: CountIfFunctionContext) => void
  /**
   * Exit a parse tree produced by the `countIfFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  exitCountIfFunction?: (ctx: CountIfFunctionContext) => void
  /**
   * Enter a parse tree produced by the `averageIfFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  enterAverageIfFunction?: (ctx: AverageIfFunctionContext) => void
  /**
   * Exit a parse tree produced by the `averageIfFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  exitAverageIfFunction?: (ctx: AverageIfFunctionContext) => void
  /**
   * Enter a parse tree produced by the `minIfsFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  enterMinIfsFunction?: (ctx: MinIfsFunctionContext) => void
  /**
   * Exit a parse tree produced by the `minIfsFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  exitMinIfsFunction?: (ctx: MinIfsFunctionContext) => void
  /**
   * Enter a parse tree produced by the `maxIfsFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  enterMaxIfsFunction?: (ctx: MaxIfsFunctionContext) => void
  /**
   * Exit a parse tree produced by the `maxIfsFunction`
   * labeled alternative in `formulaParser.ifFunctionType`.
   * @param ctx the parse tree
   */
  exitMaxIfsFunction?: (ctx: MaxIfsFunctionContext) => void
  /**
   * Enter a parse tree produced by the `singleLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  enterSingleLogicExpr?: (ctx: SingleLogicExprContext) => void
  /**
   * Exit a parse tree produced by the `singleLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  exitSingleLogicExpr?: (ctx: SingleLogicExprContext) => void
  /**
   * Enter a parse tree produced by the `parenthesizedLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  enterParenthesizedLogicExpr?: (ctx: ParenthesizedLogicExprContext) => void
  /**
   * Exit a parse tree produced by the `parenthesizedLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  exitParenthesizedLogicExpr?: (ctx: ParenthesizedLogicExprContext) => void
  /**
   * Enter a parse tree produced by the `orChainedLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  enterOrChainedLogicExpr?: (ctx: OrChainedLogicExprContext) => void
  /**
   * Exit a parse tree produced by the `orChainedLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  exitOrChainedLogicExpr?: (ctx: OrChainedLogicExprContext) => void
  /**
   * Enter a parse tree produced by the `andChainedLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  enterAndChainedLogicExpr?: (ctx: AndChainedLogicExprContext) => void
  /**
   * Exit a parse tree produced by the `andChainedLogicExpr`
   * labeled alternative in `formulaParser.logicExpr`.
   * @param ctx the parse tree
   */
  exitAndChainedLogicExpr?: (ctx: AndChainedLogicExprContext) => void
  /**
   * Enter a parse tree produced by the `parenthesizedLogicTerm`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterParenthesizedLogicTerm?: (ctx: ParenthesizedLogicTermContext) => void
  /**
   * Exit a parse tree produced by the `parenthesizedLogicTerm`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitParenthesizedLogicTerm?: (ctx: ParenthesizedLogicTermContext) => void
  /**
   * Enter a parse tree produced by the `notExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterNotExpression?: (ctx: NotExpressionContext) => void
  /**
   * Exit a parse tree produced by the `notExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitNotExpression?: (ctx: NotExpressionContext) => void
  /**
   * Enter a parse tree produced by the `booleanExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterBooleanExpression?: (ctx: BooleanExpressionContext) => void
  /**
   * Exit a parse tree produced by the `booleanExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitBooleanExpression?: (ctx: BooleanExpressionContext) => void
  /**
   * Enter a parse tree produced by the `comparisonExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterComparisonExpression?: (ctx: ComparisonExpressionContext) => void
  /**
   * Exit a parse tree produced by the `comparisonExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitComparisonExpression?: (ctx: ComparisonExpressionContext) => void
  /**
   * Enter a parse tree produced by the `scalarRightContainsExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterScalarRightContainsExpression?: (ctx: ScalarRightContainsExpressionContext) => void
  /**
   * Exit a parse tree produced by the `scalarRightContainsExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitScalarRightContainsExpression?: (ctx: ScalarRightContainsExpressionContext) => void
  /**
   * Enter a parse tree produced by the `arrayRightContainsExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterArrayRightContainsExpression?: (ctx: ArrayRightContainsExpressionContext) => void
  /**
   * Exit a parse tree produced by the `arrayRightContainsExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitArrayRightContainsExpression?: (ctx: ArrayRightContainsExpressionContext) => void
  /**
   * Enter a parse tree produced by the `unaryExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterUnaryExpression?: (ctx: UnaryExpressionContext) => void
  /**
   * Exit a parse tree produced by the `unaryExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitUnaryExpression?: (ctx: UnaryExpressionContext) => void
  /**
   * Enter a parse tree produced by the `inExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  enterInExpression?: (ctx: InExpressionContext) => void
  /**
   * Exit a parse tree produced by the `inExpression`
   * labeled alternative in `formulaParser.logicTerm`.
   * @param ctx the parse tree
   */
  exitInExpression?: (ctx: InExpressionContext) => void
  /**
   * Enter a parse tree produced by the `notExpr`
   * labeled alternative in `formulaParser.notLogicExpr`.
   * @param ctx the parse tree
   */
  enterNotExpr?: (ctx: NotExprContext) => void
  /**
   * Exit a parse tree produced by the `notExpr`
   * labeled alternative in `formulaParser.notLogicExpr`.
   * @param ctx the parse tree
   */
  exitNotExpr?: (ctx: NotExprContext) => void
  /**
   * Enter a parse tree produced by the `binaryLogicExpr`
   * labeled alternative in `formulaParser.comparisonLogicExpr`.
   * @param ctx the parse tree
   */
  enterBinaryLogicExpr?: (ctx: BinaryLogicExprContext) => void
  /**
   * Exit a parse tree produced by the `binaryLogicExpr`
   * labeled alternative in `formulaParser.comparisonLogicExpr`.
   * @param ctx the parse tree
   */
  exitBinaryLogicExpr?: (ctx: BinaryLogicExprContext) => void
  /**
   * Enter a parse tree produced by the `scalarRightContainsExpr`
   * labeled alternative in `formulaParser.scalarRightContainsLogicExpr`.
   * @param ctx the parse tree
   */
  enterScalarRightContainsExpr?: (ctx: ScalarRightContainsExprContext) => void
  /**
   * Exit a parse tree produced by the `scalarRightContainsExpr`
   * labeled alternative in `formulaParser.scalarRightContainsLogicExpr`.
   * @param ctx the parse tree
   */
  exitScalarRightContainsExpr?: (ctx: ScalarRightContainsExprContext) => void
  /**
   * Enter a parse tree produced by the `arrayRightContainsExpr`
   * labeled alternative in `formulaParser.arrayRightContainsLogicExpr`.
   * @param ctx the parse tree
   */
  enterArrayRightContainsExpr?: (ctx: ArrayRightContainsExprContext) => void
  /**
   * Exit a parse tree produced by the `arrayRightContainsExpr`
   * labeled alternative in `formulaParser.arrayRightContainsLogicExpr`.
   * @param ctx the parse tree
   */
  exitArrayRightContainsExpr?: (ctx: ArrayRightContainsExprContext) => void
  /**
   * Enter a parse tree produced by the `inExpr`
   * labeled alternative in `formulaParser.inLogicExpr`.
   * @param ctx the parse tree
   */
  enterInExpr?: (ctx: InExprContext) => void
  /**
   * Exit a parse tree produced by the `inExpr`
   * labeled alternative in `formulaParser.inLogicExpr`.
   * @param ctx the parse tree
   */
  exitInExpr?: (ctx: InExprContext) => void
  /**
   * Enter a parse tree produced by the `unaryExpr`
   * labeled alternative in `formulaParser.unaryLogicExpr`.
   * @param ctx the parse tree
   */
  enterUnaryExpr?: (ctx: UnaryExprContext) => void
  /**
   * Exit a parse tree produced by the `unaryExpr`
   * labeled alternative in `formulaParser.unaryLogicExpr`.
   * @param ctx the parse tree
   */
  exitUnaryExpr?: (ctx: UnaryExprContext) => void
  /**
   * Enter a parse tree produced by the `logicExprColumnRef`
   * labeled alternative in `formulaParser.logicExprValue`.
   * @param ctx the parse tree
   */
  enterLogicExprColumnRef?: (ctx: LogicExprColumnRefContext) => void
  /**
   * Exit a parse tree produced by the `logicExprColumnRef`
   * labeled alternative in `formulaParser.logicExprValue`.
   * @param ctx the parse tree
   */
  exitLogicExprColumnRef?: (ctx: LogicExprColumnRefContext) => void
  /**
   * Enter a parse tree produced by the `formulaInLogic`
   * labeled alternative in `formulaParser.logicExprValue`.
   * @param ctx the parse tree
   */
  enterFormulaInLogic?: (ctx: FormulaInLogicContext) => void
  /**
   * Exit a parse tree produced by the `formulaInLogic`
   * labeled alternative in `formulaParser.logicExprValue`.
   * @param ctx the parse tree
   */
  exitFormulaInLogic?: (ctx: FormulaInLogicContext) => void
  /**
   * Enter a parse tree produced by the `directValue`
   * labeled alternative in `formulaParser.logicExprValue`.
   * @param ctx the parse tree
   */
  enterDirectValue?: (ctx: DirectValueContext) => void
  /**
   * Exit a parse tree produced by the `directValue`
   * labeled alternative in `formulaParser.logicExprValue`.
   * @param ctx the parse tree
   */
  exitDirectValue?: (ctx: DirectValueContext) => void
  /**
   * Enter a parse tree produced by the `greaterThan`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  enterGreaterThan?: (ctx: GreaterThanContext) => void
  /**
   * Exit a parse tree produced by the `greaterThan`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  exitGreaterThan?: (ctx: GreaterThanContext) => void
  /**
   * Enter a parse tree produced by the `greaterThanOrEqual`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  enterGreaterThanOrEqual?: (ctx: GreaterThanOrEqualContext) => void
  /**
   * Exit a parse tree produced by the `greaterThanOrEqual`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  exitGreaterThanOrEqual?: (ctx: GreaterThanOrEqualContext) => void
  /**
   * Enter a parse tree produced by the `lessThan`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  enterLessThan?: (ctx: LessThanContext) => void
  /**
   * Exit a parse tree produced by the `lessThan`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  exitLessThan?: (ctx: LessThanContext) => void
  /**
   * Enter a parse tree produced by the `lessThanOrEqual`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  enterLessThanOrEqual?: (ctx: LessThanOrEqualContext) => void
  /**
   * Exit a parse tree produced by the `lessThanOrEqual`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  exitLessThanOrEqual?: (ctx: LessThanOrEqualContext) => void
  /**
   * Enter a parse tree produced by the `equal`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  enterEqual?: (ctx: EqualContext) => void
  /**
   * Exit a parse tree produced by the `equal`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  exitEqual?: (ctx: EqualContext) => void
  /**
   * Enter a parse tree produced by the `notEqual`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  enterNotEqual?: (ctx: NotEqualContext) => void
  /**
   * Exit a parse tree produced by the `notEqual`
   * labeled alternative in `formulaParser.binarylogicOperator`.
   * @param ctx the parse tree
   */
  exitNotEqual?: (ctx: NotEqualContext) => void
  /**
   * Enter a parse tree produced by the `containsAny`
   * labeled alternative in `formulaParser.arrayRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  enterContainsAny?: (ctx: ContainsAnyContext) => void
  /**
   * Exit a parse tree produced by the `containsAny`
   * labeled alternative in `formulaParser.arrayRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  exitContainsAny?: (ctx: ContainsAnyContext) => void
  /**
   * Enter a parse tree produced by the `containsAll`
   * labeled alternative in `formulaParser.arrayRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  enterContainsAll?: (ctx: ContainsAllContext) => void
  /**
   * Exit a parse tree produced by the `containsAll`
   * labeled alternative in `formulaParser.arrayRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  exitContainsAll?: (ctx: ContainsAllContext) => void
  /**
   * Enter a parse tree produced by the `doesNotContainAny`
   * labeled alternative in `formulaParser.arrayRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  enterDoesNotContainAny?: (ctx: DoesNotContainAnyContext) => void
  /**
   * Exit a parse tree produced by the `doesNotContainAny`
   * labeled alternative in `formulaParser.arrayRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  exitDoesNotContainAny?: (ctx: DoesNotContainAnyContext) => void
  /**
   * Enter a parse tree produced by the `contains`
   * labeled alternative in `formulaParser.scalarRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  enterContains?: (ctx: ContainsContext) => void
  /**
   * Exit a parse tree produced by the `contains`
   * labeled alternative in `formulaParser.scalarRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  exitContains?: (ctx: ContainsContext) => void
  /**
   * Enter a parse tree produced by the `doesNotContain`
   * labeled alternative in `formulaParser.scalarRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  enterDoesNotContain?: (ctx: DoesNotContainContext) => void
  /**
   * Exit a parse tree produced by the `doesNotContain`
   * labeled alternative in `formulaParser.scalarRightContainsLogicOperator`.
   * @param ctx the parse tree
   */
  exitDoesNotContain?: (ctx: DoesNotContainContext) => void
  /**
   * Enter a parse tree produced by the `in`
   * labeled alternative in `formulaParser.inLogicOperator`.
   * @param ctx the parse tree
   */
  enterIn?: (ctx: InContext) => void
  /**
   * Exit a parse tree produced by the `in`
   * labeled alternative in `formulaParser.inLogicOperator`.
   * @param ctx the parse tree
   */
  exitIn?: (ctx: InContext) => void
  /**
   * Enter a parse tree produced by the `notIn`
   * labeled alternative in `formulaParser.inLogicOperator`.
   * @param ctx the parse tree
   */
  enterNotIn?: (ctx: NotInContext) => void
  /**
   * Exit a parse tree produced by the `notIn`
   * labeled alternative in `formulaParser.inLogicOperator`.
   * @param ctx the parse tree
   */
  exitNotIn?: (ctx: NotInContext) => void
  /**
   * Enter a parse tree produced by the `isEmpty`
   * labeled alternative in `formulaParser.unaryLogicOperator`.
   * @param ctx the parse tree
   */
  enterIsEmpty?: (ctx: IsEmptyContext) => void
  /**
   * Exit a parse tree produced by the `isEmpty`
   * labeled alternative in `formulaParser.unaryLogicOperator`.
   * @param ctx the parse tree
   */
  exitIsEmpty?: (ctx: IsEmptyContext) => void
  /**
   * Enter a parse tree produced by the `isNotEmpty`
   * labeled alternative in `formulaParser.unaryLogicOperator`.
   * @param ctx the parse tree
   */
  enterIsNotEmpty?: (ctx: IsNotEmptyContext) => void
  /**
   * Exit a parse tree produced by the `isNotEmpty`
   * labeled alternative in `formulaParser.unaryLogicOperator`.
   * @param ctx the parse tree
   */
  exitIsNotEmpty?: (ctx: IsNotEmptyContext) => void
  /**
   * Enter a parse tree produced by the `numericValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  enterNumericValue?: (ctx: NumericValueContext) => void
  /**
   * Exit a parse tree produced by the `numericValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  exitNumericValue?: (ctx: NumericValueContext) => void
  /**
   * Enter a parse tree produced by the `negativeNumericValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  enterNegativeNumericValue?: (ctx: NegativeNumericValueContext) => void
  /**
   * Exit a parse tree produced by the `negativeNumericValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  exitNegativeNumericValue?: (ctx: NegativeNumericValueContext) => void
  /**
   * Enter a parse tree produced by the `stringValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  enterStringValue?: (ctx: StringValueContext) => void
  /**
   * Exit a parse tree produced by the `stringValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  exitStringValue?: (ctx: StringValueContext) => void
  /**
   * Enter a parse tree produced by the `booleanValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  enterBooleanValue?: (ctx: BooleanValueContext) => void
  /**
   * Exit a parse tree produced by the `booleanValue`
   * labeled alternative in `formulaParser.logicValue`.
   * @param ctx the parse tree
   */
  exitBooleanValue?: (ctx: BooleanValueContext) => void
  /**
   * Enter a parse tree produced by the `numericValueList`
   * labeled alternative in `formulaParser.logicValueList`.
   * @param ctx the parse tree
   */
  enterNumericValueList?: (ctx: NumericValueListContext) => void
  /**
   * Exit a parse tree produced by the `numericValueList`
   * labeled alternative in `formulaParser.logicValueList`.
   * @param ctx the parse tree
   */
  exitNumericValueList?: (ctx: NumericValueListContext) => void
  /**
   * Enter a parse tree produced by the `stringValueList`
   * labeled alternative in `formulaParser.logicValueList`.
   * @param ctx the parse tree
   */
  enterStringValueList?: (ctx: StringValueListContext) => void
  /**
   * Exit a parse tree produced by the `stringValueList`
   * labeled alternative in `formulaParser.logicValueList`.
   * @param ctx the parse tree
   */
  exitStringValueList?: (ctx: StringValueListContext) => void
  /**
   * Enter a parse tree produced by the `numericItem`
   * labeled alternative in `formulaParser.numericListItem`.
   * @param ctx the parse tree
   */
  enterNumericItem?: (ctx: NumericItemContext) => void
  /**
   * Exit a parse tree produced by the `numericItem`
   * labeled alternative in `formulaParser.numericListItem`.
   * @param ctx the parse tree
   */
  exitNumericItem?: (ctx: NumericItemContext) => void
  /**
   * Enter a parse tree produced by the `negativeNumericItem`
   * labeled alternative in `formulaParser.negativeNumericListItem`.
   * @param ctx the parse tree
   */
  enterNegativeNumericItem?: (ctx: NegativeNumericItemContext) => void
  /**
   * Exit a parse tree produced by the `negativeNumericItem`
   * labeled alternative in `formulaParser.negativeNumericListItem`.
   * @param ctx the parse tree
   */
  exitNegativeNumericItem?: (ctx: NegativeNumericItemContext) => void
  /**
   * Enter a parse tree produced by the `stringItem`
   * labeled alternative in `formulaParser.stringListItem`.
   * @param ctx the parse tree
   */
  enterStringItem?: (ctx: StringItemContext) => void
  /**
   * Exit a parse tree produced by the `stringItem`
   * labeled alternative in `formulaParser.stringListItem`.
   * @param ctx the parse tree
   */
  exitStringItem?: (ctx: StringItemContext) => void
}
